// ABOUTME: Hostnames after splitting marketing (Vercel) from the product app (Netlify).
// ABOUTME: Marketing is rayze.xyz; invoices, console, AI Lab, and gated Sigma live on app.rayze.xyz.

export const MARKETING_ORIGIN = 'https://rayze.xyz';
export const APP_ORIGIN = 'https://app.rayze.xyz';
